import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { HttpService } from '@/features/api/http.service';
import type { IOwnerList } from '@/types/api';

const OWNERS_PATH = '/owners';

export const ownersKeyFactory = createQueryKeys('owners', {
  list: () => ({
    queryKey: [OWNERS_PATH],
    queryFn: (): Promise<IOwnerList> => HttpService.get<string, IOwnerList>(OWNERS_PATH),
  }),
});

export function useOwnersQuery() {
  return useQuery({ ...ownersKeyFactory.list(), retry: false });
}
